"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDeleteRoleMutation = exports.useUpdateRoleMutation = exports.useCreateRoleMutation = exports.useGetPermissionsQuery = exports.useGetRoleQuery = exports.useLazyGetRolesQuery = exports.useGetRolesQuery = exports.rolesApi = void 0;
var react_1 = require("@reduxjs/toolkit/query/react");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
exports.rolesApi = (0, react_1.createApi)({
    reducerPath: "rolesApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.API_URL),
    tagTypes: ["Roles"],
    endpoints: function (builder) { return ({
        getRoles: builder.query({
            query: function (params) { return ({
                url: "/v1/roles",
                params: params,
            }); },
            providesTags: function (result) {
                var _a;
                var roles = ((_a = result === null || result === void 0 ? void 0 : result.content) === null || _a === void 0 ? void 0 : _a.roles) || [];
                return roles.length > 0
                    ? __spreadArray(__spreadArray([], roles.map(function (_a) {
                        var _id = _a._id;
                        return ({
                            type: "Roles",
                            id: _id,
                        });
                    }), true), [
                        { type: "Roles", id: "LIST" },
                    ], false) : [{ type: "Roles", id: "LIST" }];
            },
        }),
        getRole: builder.query({
            query: function (id) { return "/v1/roles/".concat(id); },
            providesTags: function (result, error, id) { return [{ type: "Roles", id: id }]; },
        }),
        getPermissions: builder.query({
            query: function () { return "/v1/roles/permissions"; },
        }),
        createRole: builder.mutation({
            query: function (data) { return ({
                url: "/v1/roles",
                method: "POST",
                body: data,
            }); },
            invalidatesTags: [{ type: "Roles", id: "LIST" }],
        }),
        updateRole: builder.mutation({
            query: function (_a) {
                var id = _a.id, data = _a.data;
                return ({
                    url: "/v1/roles/".concat(id),
                    method: "PATCH",
                    body: data,
                });
            },
            invalidatesTags: function (result, error, _a) {
                var id = _a.id;
                return [
                    { type: "Roles", id: id },
                    { type: "Roles", id: "LIST" },
                ];
            },
        }),
        deleteRole: builder.mutation({
            query: function (id) { return ({
                url: "/v1/roles/".concat(id),
                method: "DELETE",
            }); },
            invalidatesTags: [{ type: "Roles", id: "LIST" }],
        }),
    }); },
});
exports.useGetRolesQuery = exports.rolesApi.useGetRolesQuery, exports.useLazyGetRolesQuery = exports.rolesApi.useLazyGetRolesQuery, exports.useGetRoleQuery = exports.rolesApi.useGetRoleQuery, exports.useGetPermissionsQuery = exports.rolesApi.useGetPermissionsQuery, exports.useCreateRoleMutation = exports.rolesApi.useCreateRoleMutation, exports.useUpdateRoleMutation = exports.rolesApi.useUpdateRoleMutation, exports.useDeleteRoleMutation = exports.rolesApi.useDeleteRoleMutation;
